"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isProviderError = exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  PAYPAL_PURCHASE_FAILED: null,
  PROVIDER_ERROR: null
});

exports.default = _default;

var isProviderError = function isProviderError(message) {
  return message.startsWith('Paypal exception. Failed to create payment: Account ') && message.endsWith(' is restricted');
};

exports.isProviderError = isProviderError;